import { Card } from 'antd';
import { useForm } from 'antd/es/form/Form';
import { FunctionComponent } from 'react';
import { useTranslation } from 'react-i18next';

// components
import CompoundElement from 'components/compoundElement/compoundElement';

interface ListHeaderComponentProps {
	title: string;
	subTitle: string;
	inputLabel: string;
	isLoading: boolean;
	onSubmit: (value: string) => void;
	onChange?: () => void;
}

const ActionCreateHeaderComponent: FunctionComponent<ListHeaderComponentProps> = ({
	title,
	subTitle,
	inputLabel,
	onSubmit,
	onChange,
	isLoading,
}) => {
	const { t } = useTranslation();

	const onFinish = async (value: string) => {
		onSubmit(value);
	};

	return (
		<Card>
			<div className="mb-3">
				<h5>{title}</h5>
				<p className="text-light">{subTitle}</p>
			</div>

			<CompoundElement buttonText={t('COMMON.GENERATE')} label={inputLabel} isLoading={isLoading} onSubmit={onFinish} onChange={onChange} />
		</Card>
	);
};

export default ActionCreateHeaderComponent;
